module.exports = __webpack_public_path__ + "static/media/bogo_card_1.4f96c084.jpg";